import * as React from 'react';
import {
    BodyMediumRegular,
    H2Emphasized,
    Icon,
    ShieldCheckIcon,
    SmoothieScrollView,
    View,
    YStack,
} from 'smoothie';

import KycButton from './KycButton';

interface ExplainerProps {
    onPressNext: () => void;
}

const Explainer = ({ onPressNext }: ExplainerProps) => {
    return (
        <SmoothieScrollView>
            <YStack alignItems="center" justifyContent="space-between" gap={16}>
                <YStack gap={24}>
                    <View marginHorizontal={28} gap={24}>
                        <View
                            alignSelf="center"
                            justifyContent="center"
                            alignItems="center"
                            height={80}
                            width={80}
                            borderRadius={16}
                            backgroundColor="$gray300"
                        >
                            <Icon
                                icon={ShieldCheckIcon}
                                color="$black"
                                size={40}
                            />
                        </View>
                        <H2Emphasized textAlign="center">
                            Let&apos;s verify your identity with a few questions
                        </H2Emphasized>
                    </View>
                    <YStack gap={16}>
                        <BodyMediumRegular color="$gray1000" textAlign="center">
                            To help the government fight the funding of
                            terrorism and money laundering activities, Federal
                            law requires all financial institutions to obtain,
                            verify, and record information that identifies each
                            person who opens an account.
                        </BodyMediumRegular>
                        <BodyMediumRegular color="$gray1000" textAlign="center">
                            What this means for you: When you open an account,
                            we will ask for your name, address, date of birth,
                            and other information that will allow us to identify
                            you. We may also ask to see your driver’s license or
                            other identifying documents.
                        </BodyMediumRegular>
                    </YStack>
                </YStack>
                <View width="100%">
                    <KycButton
                        onPress={() => {
                            onPressNext();
                        }}
                        hideSecureText
                    />
                </View>
            </YStack>
        </SmoothieScrollView>
    );
};

export default Explainer;
